<script lang="ts">
  import { defineComponent } from 'vue'

  export default defineComponent({
    name: 'PoliticaComponent',
    computed: {
      isMobile() {
        return this.$vuetify.display.mobile;
      }
    }
  })
</script>

<template>
  <section :style="isMobile ? '' : 'width: 75%; margin: auto;'">
    <h1>Política de Privacidade do AF Secretaria</h1>
    <p>Ao usar nossos serviços você concorda com nossas política de privacidade.</p>

    <iframe
      width="100%"
      height="500px"
      src="https://drive.google.com/file/d/12r3M_8V3XVtDndtFsGjL-Jq7JII5_0O_/preview"
      style="border: none"
    />
  </section>
</template>

<style scoped>

</style>
